/**
 * [Phase 2c-B §4.12 NEW-3] Per-row speaker icon. Click → TTS playback via the
 * module-level singleton. Highlights orange when this row is currently active.
 *
 * Hides itself when no voice_text or when source === 'system'.
 */
import React from "react";
import { Volume2, Loader2 } from "lucide-react";
import { useTTSPlayer } from "../../contexts/TTSPlayerContext";

export default function ActivitySpeakerButton({
  activityId,
  voiceText,
  voiceSource,
  testid,
}) {
  const { state, play } = useTTSPlayer();
  if (!voiceText) return null;
  if (voiceSource === "system") return null;
  if (!activityId) return null;

  const isActive = state.playing && state.activityId === activityId;
  const isLoading = !state.playing && state.activityId === activityId;

  const handleClick = (e) => {
    e.stopPropagation();
    play({
      activityId,
      voiceText,
      snippet: voiceText.slice(0, 140),
    });
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      data-testid={testid || `activity-speaker-${activityId}`}
      aria-label={isActive ? "Audio playing" : "Listen to Adam"}
      className={`inline-flex items-center justify-center w-6 h-6 rounded-md transition-all ${
        isActive
          ? "bg-[#FF6B00]/25 text-[#FF6B00]"
          : "bg-transparent text-[#888] hover:text-[#FF6B00] hover:bg-[#FF6B00]/10"
      }`}
    >
      {isLoading ? (
        <Loader2 size={12} className="animate-spin" />
      ) : (
        <Volume2 size={12} className={isActive ? "animate-pulse" : ""} />
      )}
    </button>
  );
}
